module.exports = __webpack_public_path__ + "img/storm.491fc2c3.svg";